/*
* Product Image ScrollTo Interaction
*
**/

custom.stickyScroll = (() => {

	const breakpoint = 1024;

	const containerBlockClass = 'js-sticky-scroll';
	const baseBlockClass = 'js-sticky-scroll-base';
	const targetBlockClass = 'js-sticky-scroll-target';
	const eachChildClass = 'js-sticky-scroll-child';

	// Cache
	const headerHeight = $('.navigation').outerHeight();

	let sceneConfig = {
		topOffsets: [],
		baseBlockHeights: []
	}

	let scrollMagicObject = {
		scenes: [],
		controllers: []
	}

	function getTopOffset(index) {
		return headerHeight + parseInt($(`[data-${containerBlockClass}-id="` + index + `"]`).css('padding-top'));
	}
	function setTopOffset(index) {
		sceneConfig.topOffsets[index] = sceneConfig.topOffsets[index] || [];
		sceneConfig.topOffsets[index] = getTopOffset(index);
	}

	function getBaseBlockHeights(index) {
		return $(`[data-${containerBlockClass}-id="` + index + `"]`).find(`.${baseBlockClass}`).outerHeight();
	}
	function setBaseBlockHeights(index) {
		sceneConfig.baseBlockHeights[index] = sceneConfig.baseBlockHeights[index] || [];
		sceneConfig.baseBlockHeights[index] = getBaseBlockHeights(index);
	}

	function setVariables(index) {
		setTopOffset(index);
		setBaseBlockHeights(index);
	}

	function calculateDuration(index) {
		const $target = $(`[data-${containerBlockClass}-id="` + index + `"]`).find(`.${targetBlockClass}`);
		return sceneConfig.baseBlockHeights[index] - $target.outerHeight();
	}

	function setScene(index) {
		const duration = calculateDuration(index);

		if(duration > 0) {
			scrollMagicObject.scenes[index] = scrollMagicObject.scenes[index] || [];
			scrollMagicObject.controllers[index] = scrollMagicObject.controllers[index] || [];

			scrollMagicObject.controllers[index] = new ScrollMagic.Controller();
			scrollMagicObject.scenes[index] = new ScrollMagic.Scene({
										triggerElement: `[data-${containerBlockClass}-id="` + index + `"]`,
										duration: duration,
										triggerHook: "onLeave",
										offset: -$('.navigation').outerHeight()
									})
									.addTo(scrollMagicObject.controllers[index]);
		}
	}


	function resetAllStyles() {
		$.each($(`.${containerBlockClass}`), (index, el) => {
			const $target = $(el).find(`.${targetBlockClass}`);
			$target.removeAttr('style');
			$target.find(`.${eachChildClass}`).removeAttr('style');
		});
	}

	function resetAllScenes() {
		$.each(scrollMagicObject.scenes, (index, scene) => {
			if(scene) scene.remove();
		});
	}

	function stickyHandler(index) {
		const $target = $(`[data-${containerBlockClass}-id="` + index + `"]`).find(`.${targetBlockClass}`);

		$target.css({
			position: 'relative',
			height: sceneConfig.baseBlockHeights[index]
		});

		$target.find(`.${eachChildClass}`).css({
			position: 'fixed',
			top: sceneConfig.topOffsets[index],
			bottom: 'auto',
			width: $target.width()
		});
	}

	function releaseHandler(index, direction) {
		const $target = $(`[data-${containerBlockClass}-id="` + index + `"]`).find(`.${targetBlockClass}`);
		const bottomPos = (direction == 'FORWARD')? 0 : 'auto';

		$target.find(`.${eachChildClass}`).css({
			position: 'absolute',
			top: 'auto',
			bottom: bottomPos
		});
	}

	function initScene(index) {
		setVariables(index);
		setScene(index);
	}

	function bindHandlers(index) {
		if(scrollMagicObject.scenes[index]) {

			scrollMagicObject.scenes[index].on('enter', (event) => {
				stickyHandler(index);
			});
			scrollMagicObject.scenes[index].on('leave', (event) => {
				releaseHandler(index, event.scrollDirection);
			});
		}
	}

	function initHandler() {
		resetAllScenes();
		resetAllStyles();

		if($(window).width() >= breakpoint) {
			$.each($(`.${containerBlockClass}`), (index, el) => {
				$(el).attr(`data-${containerBlockClass}-id`, index);
				initScene(index);
				bindHandlers(index);
			});
		}
	}

	function init() {
		if($(`.${containerBlockClass}`).length > 0) {
			initHandler();
			$(window).on('resize', initHandler);
		}
	}

	return {
		init: init
	}

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/sticky-scroll.js